import { useEffect, useState } from 'react';

/** Tracks a CSS media query, re-rendering when it flips (e.g. window resize). */
export function useMediaQuery(query: string): boolean {
  // Read synchronously so the first render already mounts the right variant
  // (no mobile flash — and no wasted fetch from a briefly-mounted wrong pane).
  const [matches, setMatches] = useState(
    () => window.matchMedia(query).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}

/** Matches Tailwind's md breakpoint (768px). Mobile = below md. */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)');
}
